
import React from 'react';
import _ from 'lodash';
import { useTranslation } from "react-i18next";
import { Checkbox, Paper, TextField, Typography, IconButton } from '@mui/material';

import { CAETable, Row } from '@cae/component-library';
import { Item, Serial, SnaiV } from 'Models';
import { useCurrentUser } from '@cae/component-library';
import { Add } from '@mui/icons-material';

export interface EditModalProps {
    rowData: SnaiV;
    item: Item;
    setItem: React.Dispatch<React.SetStateAction<Item>>;
    serials: Serial[];
    serialDataContainer: any;
    setSerialDataContainer: React.Dispatch<React.SetStateAction<any>>;
}

export const EditModal: React.FC<EditModalProps> = ({ rowData, item, setItem, serials, serialDataContainer, setSerialDataContainer }) => {
    const { t } = useTranslation("snaiV");
    const { user } = useCurrentUser();
    const [ snaiSerials, setSnaiSerials ] = React.useState<Serial[]>(serials.filter(s => s.itemId === rowData.itemId && s.isActive));
    const [ newSerialNumber, setNewSerialNumber ] = React.useState<Serial>(new Serial({ itemId: item.id }));
    const months = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
    const handleDeleteSerialNumber = (serialNumber: string) => {
        let deletedSerial = snaiSerials.find((s: Serial) => s.itemId === item.id && s.serialNumber === serialNumber && s.deletedDate === null) || new Serial({ itemId: item.id, serialNumber: serialNumber, isActive: false });
        deletedSerial.isActive = false;
        let container = _.cloneDeep(serialDataContainer);
        deletedSerial.id !== 0 ? container.serialDelete.push(deletedSerial) : container.serialInsert.splice(container.serialInsert.findIndex((s: Serial) => s.itemId === item.id && s.serialNumber === serialNumber), 1);
        const newSnaiV = _.cloneDeep(snaiSerials)
        const index = newSnaiV.findIndex((s) => s.itemId === item.id && s.serialNumber === serialNumber);
        newSnaiV.splice(index, 1);
        container.serialRemaining = serials.filter(s => s.itemId === rowData.itemId && s.serialNumber !== serialNumber);
        setSnaiSerials(newSnaiV);
        setSerialDataContainer(container);
    }
    const handleAddSerialNumber = () => {
        let container = _.cloneDeep(serialDataContainer);
        let addedSerial = container.serialDelete.find((s: Serial) => s.itemId === item.id && s.serialNumber === newSerialNumber.serialNumber) || serials.find((s: Serial) => s.itemId === item.id && s.serialNumber === newSerialNumber.serialNumber) || newSerialNumber;
        container.serialDelete.splice(container.serialDelete.findIndex((s: Serial) => s.itemId === addedSerial.id && s.serialNumber === addedSerial.serialNumber), 1)
        if (!snaiSerials.find(s => s.serialNumber === addedSerial.serialNumber)) {
            if(!addedSerial.isActive){
                addedSerial.isActive = true;
                container.serialUpdate.push(addedSerial);
            }else{
                container.serialInsert.push(addedSerial);
            }
            const newSnaiV = _.cloneDeep(snaiSerials)
            newSnaiV.push(addedSerial);
            setSnaiSerials(newSnaiV);
            container.serialRemaining = serials.filter(s => s.itemId === rowData.itemId && s.serialNumber !== newSerialNumber.serialNumber);
            setSerialDataContainer(container);
        }
    }
    const handleChangeHott = (hott: boolean) => {
        let container = _.cloneDeep(serialDataContainer);
        const newItem = _.cloneDeep(item)
        newItem.isHott = hott;
        newItem.updatedBy = user.userId;
        newItem.updatedDate = new Date();
        setItem(newItem);
        container.itemChange.push(newItem);
        setSerialDataContainer(container);
    }
    const handleChangePo = (po: boolean) => {
        let container = _.cloneDeep(serialDataContainer);
        const newItem = _.cloneDeep(item)
        newItem.isPo = po;
        newItem.updatedBy = user.userId;
        newItem.updatedDate = new Date();
        setItem(newItem);
        container.itemChange.push(newItem);
        setSerialDataContainer(container);
    }
    return (
        <Paper>
            <Checkbox onChange={(e) => handleChangeHott(e.currentTarget.checked)} checked={item.isHott} />{t("isHott")}
            <Checkbox onChange={(e) => handleChangePo(e.currentTarget.checked)} checked={item.isPo} />{t("isPo")}
            <Typography>
                <IconButton disabled={(newSerialNumber.serialDate && newSerialNumber.serialNumber) ? false : true} onClick={() => handleAddSerialNumber()}>
                    <Add/>
                    </IconButton>
                <TextField label={t("serialNumber")} onChange={(v) => setNewSerialNumber({ ...newSerialNumber, serialNumber: v.currentTarget.value })} />
                <TextField
                    InputLabelProps={{
                        shrink: true,
                    }}

                    label={t("serialDate")}
                    variant='standard'
                    onChange={(v) => setNewSerialNumber({ ...newSerialNumber, serialDate: new Date(v.currentTarget.value) })}
                    type="date"
                />
            </Typography>
            <CAETable
                properties={[
                    { key: "Delete", title: t("delete"), render: (_, rowData) => <IconButton onClick={() => handleDeleteSerialNumber((rowData as Serial).serialNumber)}>X</IconButton> },
                    { key: "serialNumber", title: t("serialNumbers") },
                    {
                        key: "serialDate", title: t("serialDate"), render: (serialDate) => {
                            if (serialDate) {
                                if (serialDate instanceof Date) {
                                    serialDate.setHours(serialDate.getHours() + 4)
                                } else {
                                    let newDate = new Date(serialDate);
                                    newDate.setHours(newDate.getHours() + 4)
                                    serialDate = newDate
                                }
                                return (<div>{serialDate.getDate() + ' ' + months[serialDate.getMonth()] + ' ' + serialDate.getFullYear()}</div>)
                            }else{
                                return (<div></div>)
                            }
                        }
                    }
                ]}
                rows={snaiSerials}
            />
        </Paper>
    )
}